'use strict';
/* Unified Modal creation and handling functionality */
var modal = require('org/util/modal');

/**
 * Function to observe the consent popUp is hide so we can shift down the geoLocation popup.
 */
function observeConsentPopup() {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {   // eslint-disable-line no-unused-vars
            $('#geo-redirect-modal .modal-dialog .modal-content').css('bottom', '0');
            if (window.matchMedia('(max-width: 767px)').matches) {
                $('#geo-redirect-modal .modal-dialog .modal-content').css({ position: 'absolute', bottom: '65px' });
            }
        });
    });
    var target = document.getElementById('onetrust-banner-sdk');
    observer.observe(target, { attributes: true, attributeFilter: ['style'] });
}


module.exports = function () {
    $('document').ready(function () {
        var url = $('#geoPopupURL').data('url');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {},
            success: function (response) {
                if (response.displayModal) {
                    modal.create(response.renderedTemplate);
                }
            }
        });
    });
    $('body').on('click', '#geoPopupCloseBtn', function () {
        $('#geo-redirect-modal').modal('hide');
    }).on('change', '#geoCountrySelector', function () {
        let reqURL = $('#reqURL').val();
        let selectedCountryCode = $(this).val();
        let redirectURL;
        $.ajax({
            url: reqURL,
            type: 'post',
            dataType: 'json',
            data: { selectedCountryCode: selectedCountryCode },
            success: (res) => {
                if (res.redirectURL !== '') {
                    redirectURL = res.redirectURL;
                    window.location.replace(redirectURL);
                } else {
                    $('#geo-redirect-modal').modal('hide');
                    window.location.reload();
                }
            }
        });
    });

    $(window).on('load', function () {
        setTimeout(function () {
            try {
                observeConsentPopup();
            } catch (e) { // eslint-disable-line
            }
        }, 500);
    });
};
